<template>
  <modal name="workgate-popup-dialog" :adaptive="true" :scrollable="true" height="auto" @closed="onWorkgateModalClosed">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading"
      v-if="nowStep == 2 && fromMypage == 'mypage'">
      <el-button @click="closeDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" v-else-if="nowStep == 2">
      <el-button @click="nowStep = 1" icon="el-icon-back" style="font-size: 2rem;" type="text"></el-button>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" v-else>
      <el-button @click="closeDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>

    <!-- Step 1: 求人リスト -->
    <div id="renew2_popup_joblist_workgate" v-if="nowStep == 1">
      <div class="popup_block">
        <div class="txt_block">
          <p class="txt01">ダウンロードが完了しました！！</p>
          <h3 class="txt02" style="font-size: 1.1rem;">作成した履歴書で<br>好条件の勤め先に一緒に応募</h3>
          <p class="txt03">あなただけの限定求人</p>
        </div>
        <div style="font-size: 11px;padding-top: 10px;">
          <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a
              href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a>、<a
              href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a></p>
          <p>ワークゲートの<a href="https://www.workgate.co.jp/etc/privacy.php"
              style="color: #0044CC;border-bottom: 1px solid #0044CC;" target="_blank">プライバシーポリシー</a></p>
          <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
        </div>
        <!--求人リスト-->
        <div class="popup_item">

          <div class="carat_block" v-for="(item, index) in job_list" :key="item.offer_id" v-if="!item.is_applied">
            <div class="carat_wrap">
              <a class="carat_link"><!--このaタグは詳細ページリンク-->
                <div class="joblist_link">
                  <div class="joblist_link01" @click="clickDetail(item.offer_id)">
                    <p class="txt_category">{{ getEmployName(item) }}</p>
                    <p class="txt_area">{{ wgFormatLocation(item) }}</p>
                  </div>
                  <div class="joblist_link02" @click="clickDetail(item.offer_id)">
                    <h4 class="joblist_h4">{{ item.concise_title || item.title }}</h4>
                    <p class="joblist_txt">{{ item.company ? item.company.name : '' }} {{ wgFormatLocation(item) }}</p>
                    <p class="joblist_txt">{{ wgFormatSalary(item).slice(0, 50) }}</p>
                  </div>
                  <button type="button" :id="'pdf-' + $globalVar.dn_flag + '-workgate-completed'"
                    v-if="!item.is_applied" @click="clickDetail(item.offer_id)"
                    class="el-button el-button--success carat_btn"><span>履歴書を提出</span>
                  </button>
                  <button type="button" id="send-workgate-application" v-else
                    class="el-button el-button--success carat_btn"><span>応募済み</span>
                  </button>
                </div>
              </a>
            </div>
            <a @click="clickDetail(item.offer_id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a>
          </div>

        </div>
      </div>
    </div>

    <!-- Step 2: 求人詳細 -->
    <div id="renew2_popup_joblist_workgate" v-if="nowStep == 2">
      <div class="popup_block">
        <!--求人リスト-->
        <div class="popup_item">
          <div class="detail_block">
            <p class="txt_category">{{ getEmployName(job_detail) }}</p>
            <h4 class="joblist_h4">{{ job_detail ? (job_detail.concise_title || job_detail.title) : '' }}</h4>
            <div class="detail_list">
              <h5>募集職種</h5>
              <p>{{ getJobName(job_detail) }}</p>

              <h5>想定年収</h5>
              <p>
              <pre style="white-space: pre-wrap;">{{ wgFormatSalary(job_detail) }}</pre>
              </p>

              <h5>勤務地</h5>
              <p style="overflow-wrap: break-word;">{{ wgFormatLocation(job_detail) }}</p>

              <h5 v-if="wgGetStationName(job_detail) !== '-'">最寄り駅</h5>
              <p v-if="wgGetStationName(job_detail) !== '-'" style="overflow-wrap: break-word;">{{ wgGetStationName(job_detail) }}</p>

              <h5 v-if="job_detail && job_detail.access">アクセス</h5>
              <p v-if="job_detail && job_detail.access" style="overflow-wrap: break-word;">{{ job_detail.access }}</p>

              <h5>仕事内容</h5>
              <p>
              <pre style="white-space: pre-wrap;">{{ job_detail ? (job_detail.job_description || '-') : '-' }}</pre>
              </p>
            </div>
            <div class="detail_list">
              <h5>給与・賞与</h5>
              <p style="overflow-wrap: break-word;">{{ wgFormatSalary(job_detail) }}</p>
            </div>
            <div class="detail_list">
              <h4>企業詳細</h4>
              <h5>社名</h5>
              <p style="overflow-wrap: break-word;">{{ job_detail && job_detail.company ? job_detail.company.name : '-' }}</p>

              <h5>本社所在地</h5>
              <p style="overflow-wrap: break-word;">{{ formatCompanyAddress(job_detail) }}</p>
            </div>
            <div class="detail_img">
              <img v-for="(imgUrl, imgIndex) in getDetailImages(job_detail)" :key="imgIndex" :src="imgUrl" alt="">
            </div>
          </div>
        </div>
        <div style="font-size: 11px;">
          <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a
              href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a>、<a
              href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a></p>
          <p>ワークゲートの<a href="https://www.workgate.co.jp/etc/privacy.php"
              style="color: #0044CC;border-bottom: 1px solid #0044CC;" target="_blank">プライバシーポリシー</a></p>
          <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
          <button type="button" id="send-workgate-detail-application" @click="applyJob(job_detail)"
            class="el-button el-button--success carat_btn02"><span>履歴書を提出</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Step 3: 応募完了 -->
    <div id="renew2_popup_joblist_workgate" v-if="nowStep == 3">
      <div class="popup_block">
        <div class="txt_block" v-if="formatid != 'mypage'">
          <p class="txt01">ダウンロードが完了しました！！</p>
        </div>

        <div class="popup_item">
          <div class="complete_block">
            <p class="complete_txt">お問い合わせありがとうございました。<br>担当者から追って連絡があります。</p>
          </div>
          <!--求人リスト-->
          <div class="popup_item" v-if="formatid != 'mypage'">
            <p class="complete_txt">他のお仕事もチェック！</p>
            <div class="carat_block" v-for="(item, index) in job_list" :key="item.offer_id" v-if="!item.is_applied">
              <a>
                <div class="joblist_link">
                  <div class="joblist_link01" @click="clickDetail(item.offer_id)">
                    <p class="txt_category">{{ getEmployName(item) }}</p>
                    <p class="txt_area">{{ wgFormatLocation(item) }}</p>
                  </div>
                  <div class="joblist_link02" @click="clickDetail(item.offer_id)">
                    <h4 class="joblist_h4">
                      {{ item.concise_title || item.title }}</h4>
                    <p class="joblist_txt">{{ item.company ? item.company.name : '' }} {{ wgFormatLocation(item) }}</p>
                    <p class="joblist_txt" style="color: #e3165c;opacity: 1;font-weight: bold;">{{ wgFormatSalary(item).slice(0, 20) }}...</p>
                  </div>
                  <button type="button" :id="'pdf-' + $globalVar.dn_flag + '-workgate-completed'"
                    @click="clickDetail(item.offer_id)" class="el-button el-button--success carat_btn"><span>履歴書を提出</span>
                  </button>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </modal>
</template>

<style scoped>
#renew2_popup_joblist_workgate .popup_block {
  text-align: center;
  position: relative;
  z-index: 1;
}

#renew2_popup_joblist_workgate .popup_block .txt_block .txt02 {
  font-size: 1.2rem;
  line-height: 1.5;
  margin-top: 10px;
}

#renew2_popup_joblist_workgate .popup_block .txt_block .txt03 {
  border-bottom: 3px solid #FFF620;
  display: inline-block;
}

#renew2_popup_joblist_workgate .popup_block .popup_item {
  background: #eef5e8;
  padding: 0px 20px 20px 20px;
  width: calc(100% + 80px);
  margin: 0px -40px;
  height: 65vh;
  overflow: scroll;
  margin-top: 10px;
  border-top: 2px solid #0F9934;
  border-bottom: 2px solid #0F9934;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .carat_block {
  margin-top: 10px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .carat_block:first-child {
  margin-top: 0;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link {
  background: #fff;
  padding: 10px 20px;
  margin: 10px 20px;
  border-radius: 8px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .joblist_link01 {
  display: flex;
  align-items: center;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .joblist_link01 .txt_category {
  background: rgb(15, 153, 52);
  color: rgb(255, 255, 255);
  border-radius: 50px;
  padding: 2px 10px;
  margin-right: 5px;
  font-size: 0.5rem;
  flex-wrap: wrap;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .joblist_link01 .txt_salary {
  flex-wrap: wrap;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .joblist_link02 .joblist_h4 {
  color: #004d40;
  padding: 5px 0;
  line-height: 1.4;
  font-size: .9rem;
  text-align: left;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .joblist_link02 .joblist_txt {
  opacity: .5;
  font-size: .8rem;
  text-align: left;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_link .carat_btn {
  background-color: #E3165C;
  border-color: #E3165C;
  margin-top: 10px;
  width: 100%;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .joblist_detail_link {
  font-size: 0.8rem;
}
</style>

<style scoped>
#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block {
  padding-right: 20px;
  padding-left: 20px;
  text-align: left;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .txt_category {
  display: inline-block;
  background: rgb(15, 153, 52);
  color: rgb(255, 255, 255);
  border-radius: 50px;
  padding: 2px 10px;
  margin-right: 5px;
  font-size: 0.5rem;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .joblist_h4 {
  padding: 5px 0 0;
  font-size: 1rem;
  color: #004d40;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .detail_list {
  border-top: 1px solid #DFDFDF;
  padding-top: 20px;
  margin-top: 20px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .detail_img {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 20px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .detail_img img {
  width: calc(100% / 2);
  object-fit: cover;
  height: 120px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .detail_list h5 {
  margin-top: 10px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .detail_block .detail_list h5:first-child {
  margin-top: 0;
}

#renew2_popup_joblist_workgate .popup_block .carat_btn02 {
  background-color: #E3165C;
  border-color: #E3165C;
  margin: 10px auto;
  width: 100%;
}
</style>

<style scoped>
#renew2_popup_joblist_workgate .popup_block .popup_item .complete_block {
  padding-top: 50px;
}

#renew2_popup_joblist_workgate .popup_block .popup_item .complete_txt {
  margin-bottom: 10px;
  font-size: 1rem;
  font-weight: bold;
}

.v--modal-box.v--modal {
  padding: 20px;
}

.v--modal-close-top {
  position: relative;
  z-index: 5;
}
</style>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { wrapMittPopupHandler } from '@/plugins/emitter'

import _ from '@/assets/lib/my-lodash'
import workgateHelpersMixin from '@/mixins/workgate-helpers-mixin'
export default {
  mixins: [workgateHelpersMixin],
  components: {
  },
  data: function () {
    return {
      job_list: [],
      nowStep: 1,
      job_detail: null,
      formatid: '',
      keyword: '',
      area: '',
      fullscreenLoading: false,
      fromMypage: '',
      // ユーザーデータ（localStorage から取得）
      storedBasicData: null,
      storedFormatData: null,
      storedResumeFormatData: null
    }
  },
  created: function () {
  },
  methods: {
    // --- メインエントリ ---
    openDialog: async function (formatId, previewFormat, basicData, keyword, area) {
      // 必須項目チェック — 不足があればポップアップを表示しない
      const basic = basicData || {}
      const email = basic.email || (this.$firebase.user && this.$firebase.user.email) || ''
      let telephone = String(basic.tel1 || '') + String(basic.tel2 || '') + String(basic.tel3 || '')
      telephone = telephone.replace(/[^0-9０-９]/g, '')
      if (!email || !basic.lastName || !basic.firstName ||
        !basic.lastNameFurigana || !basic.firstNameFurigana ||
        !basic.birthYear || !basic.birthMonth || !basic.birthDay ||
        !basic.address1 || !telephone) {
        return
      }

      this.$modal.show('workgate-popup-dialog')
      this.formatid = formatId
      this.keyword = keyword || ''
      this.area = area || ''
      this.nowStep = 1
      this.job_list = []
      this.job_detail = null
      this.fromMypage = formatId

      // localStorage からユーザーデータを取得
      const app = this
      const BACKUP_KEYS_LIST = [
        'format_rirekisho',
        'format_shokumukeirekisho',
        'basicData',
        'recentEdit'
      ]
      const storageData = {}
      await this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (_.includes(BACKUP_KEYS_LIST, key)) {
            storageData[key] = value
          }
        },
        function (err) {
          if (err) {
            console.error(err)
          }
        }
      )
      this.storedBasicData = basicData || storageData.basicData || null
      this.storedFormatData = storageData.format_rirekisho || null
      this.storedResumeFormatData = storageData.format_shokumukeirekisho || null

      // displayDialog APIにログを送信
      const logFormData = new FormData()
      logFormData.append('uuid', this.$firebase.user.uid)
      logFormData.append('storage_data', JSON.stringify(storageData))
      logFormData.append('format_id', this.formatid)
      logFormData.append('dialog_name', 'workgate_dialog')
      logFormData.append('permission_type', 1)
      logFormData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      logFormData.append('version', '2')
      logFormData.append('site_flag', 'r')
      logFormData.append('app_flag', this.$site.appFlag)
      this.$axios.post(this.$varuna.endPoints.displayDialog, logFormData, { timeout: 60000 })

      // ワークゲート求人リスト取得（フォーマットに応じた出し分け）
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('keyword', this.keyword || '')
      formData.append('area', this.area || '')
      formData.append('address', (basicData && basicData.address1) || '')
      formData.append('occupation', this.getOccupationByFormat(this.formatid))
      formData.append('storage_data', '')
      formData.append('format_id', this.formatid)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('site_flag', 'r')

      this.fullscreenLoading = true
      this.$axios
        .post(this.$varuna.endPoints.getWorkgateList, formData, { timeout: 30000 })
        .then(function (response) {
          app.$modal.show('workgate-popup-dialog')
          const offers = (response.data && Array.isArray(response.data.offers)) ? response.data.offers : []
          app.job_list = offers
          app.fullscreenLoading = false
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: 'あなたにピッタリの求人リストを取得しました',
            type: 'info'
          })
        })
        .catch(function (error) {
          console.error('ワークゲート求人取得エラー:', error)
          app.$message({
            message: '求人リスト取得に失敗しました',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },

    // --- 求人詳細表示 ---
    clickDetail: async function (offerId) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }

      const formData = new FormData()
      formData.append('offer_id', String(offerId))

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.getWorkgateDetail, formData, { timeout: 30000 })
        .then(function (response) {
          const rawDetail = response && response.data ? response.data : null
          const detail = (rawDetail && rawDetail.item) ? rawDetail.item : rawDetail
          if (detail && !detail.error) {
            app.job_detail = detail
          } else {
            // フォールバック: リストデータから表示
            let fallback = null
            for (let i = 0; i < app.job_list.length; i++) {
              if (app.job_list[i].offer_id == offerId) {
                fallback = app.job_list[i]
                break
              }
            }
            app.job_detail = fallback
          }
          app.nowStep = 2
        })
        .catch(function (error) {
          console.error('ワークゲート求人詳細取得エラー:', error)
          // フォールバック: リストデータから表示
          let fallback = null
          for (let i = 0; i < app.job_list.length; i++) {
            if (app.job_list[i].offer_id == offerId) {
              fallback = app.job_list[i]
              break
            }
          }
          if (fallback) {
            app.job_detail = fallback
            app.nowStep = 2
          } else {
            app.$message({
              message: '求人詳細取得に失敗しました',
              type: 'error'
            })
          }
        })
    },

    // --- 応募 ---
    applyJob: async function (offer) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }

      if (!offer || !offer.offer_id) {
        this.$message({
          message: '応募対象の求人情報が不足しています',
          type: 'warning'
        })
        return
      }

      const payload = this.buildApplyPayload()
      if (payload.missingFields.length > 0) {
        this.$message({
          message: '応募に必要な情報が不足しています: ' + payload.missingFields.join('、'),
          type: 'warning'
        })
        return
      }

      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('offer_id', String(offer.offer_id))
      formData.append('email', payload.email)
      formData.append('lastname', payload.lastname)
      formData.append('firstname', payload.firstname)
      formData.append('lastname_kana', payload.lastname_kana)
      formData.append('firstname_kana', payload.firstname_kana)
      formData.append('birth', payload.birth)
      formData.append('pref_code', String(payload.pref_code))
      formData.append('address1', payload.address1)
      if (payload.telephone) formData.append('telephone', payload.telephone)
      if (payload.zip_code) formData.append('zip_code', payload.zip_code)
      if (payload.address2) formData.append('address2', payload.address2)
      formData.append('gender', String(payload.gender))
      if (payload.education) formData.append('education', JSON.stringify(payload.education))
      if (payload.job_history) formData.append('job_history', JSON.stringify(payload.job_history))
      if (payload.current_job) formData.append('current_job', JSON.stringify(payload.current_job))
      if (payload.introduction) formData.append('introduction', JSON.stringify(payload.introduction))
      formData.append('environment', JSON.stringify(payload.environment))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('format_id', this.formatid || '')
      formData.append('keyword', this.keyword || '')
      formData.append('area', this.area || '')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applyWorkgate, formData, { timeout: 60000 })
        .then(function (response) {
          const data = response && response.data ? response.data : {}
          if (data.apply_id) offer.apply_id = data.apply_id
          offer.is_applied = true

          // リスト内の同一求人も更新
          for (let k = 0; k < app.job_list.length; k++) {
            if (app.job_list[k].offer_id == offer.offer_id) {
              app.$set(app.job_list[k], 'is_applied', true)
            }
          }

          app.nowStep = 3
        })
        .catch(function (error) {
          const status = error && error.response ? error.response.status : null
          if (status === 409) {
            offer.is_applied = true
            for (let k = 0; k < app.job_list.length; k++) {
              if (app.job_list[k].offer_id == offer.offer_id) {
                app.$set(app.job_list[k], 'is_applied', true)
              }
            }
            app.$message({
              message: '既に応募済みです。',
              type: 'info'
            })
            return
          }
          console.error('ワークゲート応募エラー:', error)
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },

    closeDialog: function () {
      // 実際の emit は modal の @closed（onWorkgateModalClosed）に集約。
      // ×ボタン・オーバーレイ・ESC など全ての閉じ方で1回だけ発火させるため。
      this.$modal.hide('workgate-popup-dialog')
    },

    // ワークゲートが閉じた時（閉じ方を問わず）に発火。FormatEdit 側で YFプロモのトリガーに使う。
    onWorkgateModalClosed: function () {
      this.$eventHub.$emit('workgate-popup-dialog-closed')
    },

    // --- 表示ヘルパー（mixin: workgate-helpers-mixin から提供） ---
    getOccupationByFormat: function (formatId) {
      if (formatId === 'rerekisho_part_time' || formatId === 'rirekisho_part_time2') {
        return 'アルバイト'
      }
      return '正社員'
    },
    getEmployName: function (item) {
      if (!item) return '-'
      if (item.employ_name) return item.employ_name
      if (item.employ && item.employ.name) return item.employ.name
      return '-'
    },
    getJobName: function (item) {
      if (!item) return '-'
      if (item.job_name) return item.job_name
      if (item.job && item.job.name) return item.job.name
      return '-'
    },
    formatCompanyAddress: function (item) {
      if (!item || !item.company) return '-'
      const loc = item.company.location
      if (!loc) return '-'
      const parts = []
      if (loc.pref) parts.push(loc.pref)
      if (loc.city) parts.push(loc.city)
      if (loc.address) parts.push(loc.address)
      return parts.length > 0 ? parts.join('') : '-'
    },
    getDetailImages: function (item) {
      if (!item) return []
      const imgs = []
      if (item.image1) imgs.push(item.image1)
      if (item.image2) imgs.push(item.image2)
      return imgs
    },

    // --- 応募ペイロード構築 ---
    buildApplyPayload: function () {
      const basic = this.storedBasicData || {}
      const email = basic.email || (this.$firebase.user && this.$firebase.user.email) || ''
      const lastname = basic.lastName || ''
      const firstname = basic.firstName || ''
      const lastnameKana = basic.lastNameFurigana || ''
      const firstnameKana = basic.firstNameFurigana || ''
      const birth = this.wgFormatBirth(basic.birthYear, basic.birthMonth, basic.birthDay)
      const pref = this.wgParsePrefecture(basic.address1 || '')
      const prefCode = pref.code
      const address1 = pref.name
        ? (basic.address1 || '').replace(pref.name, '')
        : (basic.address1 || '')
      const address2 = basic.address2 || ''
      const zipCode = this.wgNormalizeDigits(basic.postNumber || '')
      const telephone = this.wgNormalizeDigits((basic.tel1 || '') + (basic.tel2 || '') + (basic.tel3 || ''))
      const gender = Number(basic.sex || 0) === 1 ? 1 : 2
      const formatData = this.storedFormatData || {}
      const resume = this.storedResumeFormatData || {}
      const jobHistory = this.wgBuildJobHistory(basic.jobHistories ? basic : (formatData.jobHistories ? formatData : resume))
      const education = this.wgBuildEducation(basic.educationalHistories ? basic : (formatData.educationalHistories ? formatData : resume))
      const introduction = this.wgBuildIntroduction(basic.licenseHistories ? basic : (formatData.licenseHistories ? formatData : (resume.licenseHistories ? resume : {})))
      const currentJob = jobHistory ? null : { select: 11, textarea: '' }

      const missingFields = []
      if (!email) missingFields.push('メールアドレス')
      if (!lastname) missingFields.push('姓')
      if (!firstname) missingFields.push('名')
      if (!lastnameKana) missingFields.push('セイ')
      if (!firstnameKana) missingFields.push('メイ')
      if (!birth) missingFields.push('生年月日')
      if (!prefCode) missingFields.push('住所(都道府県)')
      if (!address1) missingFields.push('住所')
      if (!telephone) missingFields.push('電話番号')
      if (!education) missingFields.push('学歴')

      return {
        email,
        lastname,
        firstname,
        lastname_kana: lastnameKana,
        firstname_kana: firstnameKana,
        birth,
        gender,
        zip_code: zipCode,
        pref_code: prefCode,
        address1,
        address2,
        telephone,
        education,
        job_history: jobHistory,
        current_job: currentJob,
        introduction,
        environment: {
          user_agent: navigator.userAgent || ''
        },
        missingFields
      }
    }
  },
  beforeMount: function () {
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openDialog = wrapMittPopupHandler(this, 'openDialog')
    this.$emitter.on('open-workgate-popup-dialog', this._mittGVPopup_openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$emitter.off('open-workgate-popup-dialog', this._mittGVPopup_openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
